export function formatPhone(value) {
  const digits = String(value).replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function initPhoneMask(input) {
  input.addEventListener('input', () => {
    input.value = formatPhone(input.value);
  });
}

function initPasswordToggle(button) {
  const wrapper = button.closest('.raf-sign-up-form-password-wrapper');
  if (!wrapper) return;
  const input = wrapper.querySelector('input');
  const eyeIcon = button.querySelector('.raf-sign-up-eye-icon');
  const eyeSlashIcon = button.querySelector('.raf-sign-up-eye-slash-icon');
  if (!input || !eyeIcon || !eyeSlashIcon) return;

  button.addEventListener('click', () => {
    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    eyeIcon.style.display = isHidden ? '' : 'none';
    eyeSlashIcon.style.display = isHidden ? 'none' : '';
    button.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
  });
}

export function signUpFormEnhancements() {
  const phone = document.querySelector('.raf-sign-up-form-input--phone');
  if (phone) initPhoneMask(phone);

  document.querySelectorAll('.raf-sign-up-form-password-toggle').forEach(initPasswordToggle);
}
